export const CONSENT_MOBILE_ALLOWED_PATHS = [
  'login',
  'forgotpassword',
  'forgotusername',
  'register',
];

export const CONSENT_PATH = '/login/consent';
